module.exports = __webpack_public_path__ + "img/583.a94e96ca.jpg";